import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '../constants/styles';

import Spinner from './Spinner';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

const ButtonBase = styled.button`
    ${FONT_FAMILY.multipleRegularCss};
    font-weight: 300;
    background-color: ${(props) => (props.primary ? COLORS.rakutenRed : 'transparent')};
    border: none;
    border-radius: ${(props) => (props.border === 'round' ? '22px' : '4px')};
    font-size: 1rem;
    color: ${(props) => (props.primary ? COLORS.white : COLORS.grey7)};
    width: ${(props) => props.width};
    line-height: 1;
    padding: 0;
    max-width: 100%;
    min-height: ${(props) => (props.height ? props.height : '50px')};
    min-width: 100px;
    overflow-wrap: break-word;
    word-break: break-all;
    display: flex;
    justify-content: center;
    align-items: center;

    &:focus {
        background-color: ${COLORS.lightRed};
        color: ${(props) => props.focusColor};
    }

    &:hover {
        background-color: ${COLORS.lightRed};
        box-shadow: 0 5px 10px 0 ${COLORS.lightGrey};
        color: ${COLORS.white};
        cursor: pointer;

        &:disabled {
            background-color: ${(props) => (props.primary ? '#ebebeb' : 'transparent')};
            box-shadow: none;
            border: none;
            cursor: not-allowed;
        }
    }

    &:disabled {
        background-color: ${(props) => (props.primary ? '#ebebeb' : 'transparent')};
        color: #d4d4d4;
        opacity: 0.7;
    }

    &:active {
        background-color: ${COLORS.darkRed};
    }

    &.success {
        background-color: ${COLORS.green};
        border-color: ${COLORS.green};
    }
`;

const Button = ({
    id,
    primary,
    width,
    text,
    icon,
    onClick,
    loading,
    success,
    disabled,
    type = 'button',
    qaId = '',
    focusColor,
    border,
    height,
    iconPosition = 'Left',
}) => (
    <ButtonBase
        id={id}
        primary={primary}
        type={type}
        width={width}
        onClick={onClick}
        disabled={disabled}
        className={success ? 'success' : ''}
        data-qa-id={qaId}
        focusColor={focusColor}
        border={border}
        height={height}
        iconPosition={iconPosition}
    >
        {icon && iconPosition === 'Left' && <span>{icon}</span>}
        {!loading && TranslationHelpers.getFormattedMessage(text.id)}
        {loading && <Spinner size={15} color={COLORS.white} />}
        {icon && iconPosition === 'Right' && <span>{icon}</span>}
    </ButtonBase>
);

Button.propTypes = {
    id: PropTypes.string,
    primary: PropTypes.bool,
    big: PropTypes.bool,
    text: PropTypes.object,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    loading: PropTypes.bool,
    width: PropTypes.string,
    focusColor: PropTypes.string,
    border: PropTypes.string,
    height: PropTypes.string,
    iconPosition: PropTypes.string,
};

export default Button;
